"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchExistingJointProductSurrogateId = fetchExistingJointProductSurrogateId;
const operators_1 = require("../types/carrierQuestionnaire/conditions/operators");
const queryOperators_1 = require("../types/carrierQuestionnaire/conditions/queryOperators");
function fetchExistingJointProductSurrogateId(repeatableCollectionId, jointProductRelatedNodeIds) {
    return {
        select: [],
        selectRepeatable: jointProductRelatedNodeIds.map((jointProductRelatedNodeId) => {
            return {
                fromCollection: repeatableCollectionId,
                selectWithConditions: {
                    nodeId: jointProductRelatedNodeId.surrogateId,
                    selectIf: {
                        conditions: [
                            {
                                nodeId: jointProductRelatedNodeId.productTypeId,
                                operator: operators_1.ComparisonOperators.equal,
                                value: 'joint', // Turn into a product type
                            },
                        ],
                    },
                    defaultValue: undefined,
                },
            };
        }),
        operator: queryOperators_1.QueryOperators.fetch,
        operatorParams: {
            fetch: {
                firstNonEmptyValueAt: jointProductRelatedNodeIds.map((jointProductRelatedNodeId) => jointProductRelatedNodeId.surrogateId),
            },
        },
    };
}
